export const SESSION_CREATE = 'session/SESSION_CREATE';
export const SESSION_CREATE_SUCCESS = 'session/SESSION_CREATE_SUCCESS';
export const SESSION_CREATE_ERROR = 'session/SESSION_CREATE_ERROR';
export const SESSION_UPDATE_SUCCESS = 'session/SESSION_UPDATE_SUCCESS';
export const SESSION_SET_WELCOME_MESSAGE = 'session/SET_WELCOME_MESSAGE';
export const SESSION_FETCH_SUCCESS = 'session/SESSION_FETCH_SUCCESS';
export const SESSION_UPDATE_URL = 'session/SESSION_UPDATE_URL';

export const sessionEventTypes = {
  SESSION_CREATE,
  SESSION_CREATE_SUCCESS,
  SESSION_CREATE_ERROR,
  SESSION_UPDATE_SUCCESS,
  SESSION_SET_WELCOME_MESSAGE,
  SESSION_FETCH_SUCCESS,
  SESSION_UPDATE_URL,
};

export function sessionCreateSuccess(payload) {
  return { type: SESSION_CREATE_SUCCESS, payload };
}

export function sessionFetchSuccess(payload) {
  return { type: SESSION_FETCH_SUCCESS, payload };
}

export function sessionCreateError() {
  return { type: SESSION_CREATE_ERROR };
}

export function sessionUpdateSuccess(payload) {
  return { type: SESSION_UPDATE_SUCCESS, payload };
}

export function updateSessionUrl(payload) {
  return { type: SESSION_UPDATE_URL, payload };
}

export function setSessionWelcomeMessage(payload) {
  return { type: SESSION_SET_WELCOME_MESSAGE, payload };
}

export default {
  sessionCreateSuccess,
  sessionFetchSuccess,
  sessionCreateError,
  sessionUpdateSuccess,
  updateSessionUrl,
  setSessionWelcomeMessage,
};
